module.exports = __webpack_public_path__ + "img/hero-mint.7b1f5e99.png";